var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Editar Concedente")]),_c('b-card',{attrs:{"no-body":""}},[(_setup.isPending)?_c('div',{staticClass:"text-center py-4"},[_c('b-spinner',{attrs:{"label":"Carregando concedente"}})],1):_c(_setup.TheForm,{key:_setup.id,on:{"saved":_setup.refetch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }